import {fork, select, takeEvery, put, cancel} from "redux-saga/effects";
import {StatusAction, StatusRequiredAction} from "../state/status";
import {Task} from "redux-saga";
import {AppState} from "../state";
import {source} from "./source";
import {SourceAction} from "../state/source";
import {InstanceAction} from "../state/instance";


export function * requiredstatus() {

    let task:Task|undefined;

    yield takeEvery<StatusRequiredAction>("RequiredStatus", function * (action) {
        if (action.payload === "STOP") {
            if (task) {
                yield cancel(task)
            }
            task = undefined;
            yield put<StatusAction>({
                type: "Status",
                payload: "STOPPED"
            });
            yield put<SourceAction>({
                type: "Source",
                payload: {
                    type: "None"
                }
            });
        } else {
            if (!task) {
                const appState:AppState = yield select();
                const newInput = appState.input;
                if (newInput?.streams || newInput?.slug) {
                    yield put<InstanceAction>({
                        type: "Instance",
                        payload: new Date().getTime()
                    });
                    task = yield fork(source, newInput);
                }
            }
        }
    });
}